// extracted by mini-css-extract-plugin
module.exports = {"my_orders_advertising_card":"OrderAdvertisingCard_my_orders_advertising_card__lcGHZ"};